<div class="scrollable-container">
  <router-outlet (activate)="onActivate($event)"></router-outlet>
  <section>
  </section>
</div>
<app-loader [corporate]="corporate"></app-loader>
<gusl-shared-snackbar></gusl-shared-snackbar>
